import httpClient from '../http_client/http_client';
import UserEntity from '../../entities/user/user_entity';
import UserPropertyEntity from '../../entities/user/user_property_entity';
import ContractMemberEntity from '../../entities/contract/contract_member_entity';
import IContractMemberEntity from "../../interfaces/icontract_member_entity.type";
import ILoginRequestBody from "../../interfaces/login_request_body.type";

export class UserHttpRequests {
   login: Function = (
      environment: string,
      requestBody: ILoginRequestBody,
      callbacks: {
         success: Function,
         failure: Function
      }) => {
      if(environment.toLowerCase() === 'production'){
         httpClient.changeBaseUrlToProduction();
      }
      httpClient.request({
         method: 'post',
         url: 'v1/users/login',
         data: {
            id: requestBody.username,
            auth: {
               password: requestBody.password,
               type: 'password'
            }
         }
      }, {
         success: (response: any) => {
            httpClient.setAuthToken(response.data.token);
            callbacks.success('Login successful');
         },
         failure: (error: any) => {
            callbacks.failure(error);
         }
      });
   };

   findUser: Function = (
      identifier: {
         email?: string,
         phone_number?: string,
         username?: string
      },
      callbacks: {
         success: Function,
         failure: Function
      }) => {

      httpClient.request({
         method: 'post',
         url: 'v1/users/find',
         data: {
            id: identifier.email
         }
      }, {
         success: (response: any) => {
            let userData = {
               id: response.data.id,
               username: response.data.username,
               email: response.data.email,
               first_name: response.data.first_name,
               last_name: response.data.last_name,
               display_name: response.data.display_name,
               verified_email: response.data.verified_email,
               roles: response.data.roles,
               properties: response.data.properties,
               phone_number: response.data.phone_number,
               phone_verified: response.data.phone_verified,
               created: response.data.created,
               contract_ids: undefined,
               auth_types: response.data.auth_types,
            };

            if(response.data.contract_ids && response.data.contract_ids.length){
               userData.contract_ids = response.data.contract_ids.map((contract: IContractMemberEntity) => new ContractMemberEntity(contract));
            }
            if(Object.keys(response.data.properties).length > 0){
               userData.properties = new UserPropertyEntity(response.data.properties);
            }

            const user = new UserEntity(userData);
            callbacks.success(user);
         },
         failure: (error: any) => {
            callbacks.failure(error);
         }
      });
   };
}

const userHttpRequestInstance = new UserHttpRequests();

export default userHttpRequestInstance;
